import { render, staticRenderFns } from "./LegalTermsAndConditions.vue?vue&type=template&id=58e2be4d&scoped=true"
import script from "./LegalTermsAndConditions.vue?vue&type=script&lang=ts"
export * from "./LegalTermsAndConditions.vue?vue&type=script&lang=ts"
import style0 from "./LegalTermsAndConditions.vue?vue&type=style&index=0&id=58e2be4d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e2be4d",
  null
  
)

export default component.exports